import { EntityCondition } from "../../entity/EntityCondition";

export class DtoConditionsDeleteRes extends EntityCondition {
  public message: string | null = null;
}
